import React, { useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { cn } from '@/utils/cn';

export function SubTaskDetailPage() {
  const { subTaskId } = useParams();
  const [activeTab, setActiveTab] = useState('overview');

  return (
    <div className="mx-auto max-w-screen-2xl space-y-4 pb-10 pt-4 px-4">
      {/* Header & Breadcrumbs */}
      <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
        <div className="space-y-1">
          <div className="flex items-center gap-2 sm:text-sm text-xs text-slate-400 tracking-wider">
             <Link to="/work-orders" className="hover:text-emerald-600 transition-colors">Công việc</Link>
             <i className="ri-arrow-right-s-line" />
             <span className="text-slate-900">Chi tiết công việc con</span>
          </div>
          <h1 className="text-2xl text-slate-900 tracking-tight">Chi tiết công việc con</h1>
          <p className="sm:text-sm text-xs text-slate-500">Quản lý và theo dõi tiến độ công việc con</p>
        </div>
        <div className="flex items-center gap-2">
          {/* Action Toolbar placed right under header according to Rule 11 */}
          <Link to={`/work-orders/sub-tasks/edit/${subTaskId}`} className="h-10 rounded-md border border-slate-200 bg-white px-4 sm:text-sm text-xs text-slate-600 hover:bg-slate-50 transition-all flex items-center gap-2">
            <i className="ri-edit-line text-emerald-600" />
            Chỉnh sửa
          </Link>
          <button className="h-10 rounded-md bg-emerald-800 px-6 sm:text-sm text-xs text-white hover:bg-emerald-900 transition-all flex items-center gap-2">
            <i className="ri-check-double-line text-lg" />
            Cập nhật tiến độ
          </button>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 items-start mt-4">
        {/* Main Content Area */}
        <div className="lg:col-span-8 xl:col-span-9 space-y-6">
           {/* Tabs */}
           <div className="flex items-center gap-6 border-b border-slate-200">
              <button 
                onClick={() => setActiveTab('overview')}
                className={cn("pb-3 sm:text-sm text-xs transition-all border-b-2 font-medium", activeTab === 'overview' ? "text-emerald-700 border-emerald-700" : "text-slate-500 border-transparent hover:text-slate-700")}
              >
                Tổng quan
              </button>
              <button 
                onClick={() => setActiveTab('materials')}
                className={cn("pb-3 sm:text-sm text-xs transition-all border-b-2 font-medium", activeTab === 'materials' ? "text-emerald-700 border-emerald-700" : "text-slate-500 border-transparent hover:text-slate-700")}
              >
                Vật tư & Thiết bị
              </button>
              <button 
                onClick={() => setActiveTab('discussion')}
                className={cn("pb-3 sm:text-sm text-xs transition-all border-b-2 font-medium", activeTab === 'discussion' ? "text-emerald-700 border-emerald-700" : "text-slate-500 border-transparent hover:text-slate-700")}
              >
                Thảo luận
              </button>
           </div>

           {/* Tab Content Placeholder */}
           <div className="rounded-md border border-slate-100 bg-white p-6 h-64 flex flex-col items-center justify-center text-slate-400">
              <i className="ri-tools-line text-4xl mb-2 text-slate-300" />
              <p className="sm:text-sm text-xs">Nội dung tab {activeTab} (Đang xây dựng...)</p>
           </div>
        </div>

        {/* Detail Sidebar */}
        <div className="lg:col-span-4 xl:col-span-3 space-y-4">
           {/* Status Block */}
           <div className="rounded-md border border-slate-100 bg-white p-4 space-y-4">
              <h3 className="sm:text-sm text-xs text-slate-800 font-medium border-b border-slate-50 pb-2">Trạng thái</h3>
              
              <div className="space-y-3">
                 <div>
                    <p className="sm:text-sm text-xs text-slate-500 mb-1">Mã công việc con</p>
                    <p className="p-3 text-blue-600 sm:text-sm text-xs bg-blue-50 rounded-md font-mono">{subTaskId || 'ST-0000'}</p>
                 </div>
                 <div>
                    <p className="sm:text-sm text-xs text-slate-500 mb-1">Tiến độ hiện tại</p>
                    <div className="flex items-center gap-2">
                       <span className="sm:text-sm text-xs font-medium text-emerald-700">0%</span>
                       <div className="h-2 flex-1 rounded-full bg-slate-100 overflow-hidden">
                          <div className="h-full bg-emerald-500 w-0" />
                       </div>
                    </div>
                 </div>
              </div>
           </div>

           {/* Assignment Block */}
           <div className="rounded-md border border-slate-100 bg-white p-4 space-y-4">
              <h3 className="sm:text-sm text-xs text-slate-800 font-medium border-b border-slate-50 pb-2">Phân công</h3>
              <div className="flex items-center gap-3">
                 <div className="h-10 w-10 rounded-full bg-slate-100 border border-slate-200 flex items-center justify-center text-slate-400">
                    <i className="ri-user-line" />
                 </div>
                 <div>
                    <p className="sm:text-sm text-xs text-slate-800 font-medium">Chưa gán</p>
                    <p className="text-xs text-slate-500">Người phụ trách</p>
                 </div>
              </div>
           </div>
        </div>
      </div>
    </div>
  );
}

export default SubTaskDetailPage;
